import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import I18n from 'i18n-react';
import payment from 'payment';
import './CardField.css';

const propTypes = {
  id: PropTypes.string.isRequired,
  changeValue: PropTypes.func.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string
};

const defaultProps = {
  label: '',
  required: false,
  errorMessage: '',
  placeholder: ''
};

const ACCEPT_CARDS = ['visa', 'mastercard', 'amex', 'dinersclub', 'elo', 'hipercard'];

class CardField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValidState: true,
      value: '',
      type: null
    };
    this.addEloType();
  }

  addEloType() {
    payment.removeFromCardArray('discover');
    payment.getCardArray().forEach(card => {
      if (card.type === 'elo') {
        card.pattern = /^401178|^401179|^431274|^438935|^451416|^457393|^457631|^457632|^504175|^627780|^636297|^636369|^636368|^(506699|5067[0-6]\d|50677[0-8])|^(50900\d|5090[1-9]\d|509[1-9]\d{2})|^65003[1-3]|^(65003[5-9]|65004\d|65005[0-1])|^(65040[5-9]|6504[1-3]\d)|^(65048[5-9]|65049\d|6505[0-2]\d|65053[0-8])|^(65054[1-9]|6505[5-8]\d|65059[0-8])|^(65070\d|65071[0-8])|^65072[0-7]|^(65090[1-9]|65091\d|650920)|^(65165[2-9]|6516[6-7]\d)|^(65500\d|65501\d)|^(65502[1-9]|6550[3-4]\d|65505[0-8])|^(65092[1-9]|65097[0-8])/;
      }
    });
  }

  validate = () => {
    return this.validateField(this.state.value);
  };

  validateField(value) {
    let errorMessage;
    let isFilled = !this.props.required || value.length > 0;
    let isValid = true;

    if (!isFilled) {
      errorMessage = 'components.checkoutInfo.card.requiredErrorMessage';
      isValid = false;
    } else if (
      !payment.fns.validateCardNumber(value) ||
      ACCEPT_CARDS.indexOf(this.state.type) === -1
    ) {
      errorMessage = this.props.errorMessage;
      isValid = false;
    }

    this.setState({
      isValidState: isValid,
      errorMessage: errorMessage,
      value: value
    });
    this.props.changeValue(value, this.state.type);

    return isValid;
  }

  onChange(value) {
    let valueStripped = value.replace(/[^0-9 ]/g, '');
    let valueFormatted = payment.fns.formatCardNumber(valueStripped);

    this.setState({
      value: valueFormatted
    });

    let type = null;

    if (value.length > 5) {
      type = payment.fns.cardType(value);
    }

    this.setState({
      type: type
    });

    this.props.changeValue(this.state.value, this.state.type);

    // Fix bug cursor Android
    const component = ReactDOM.findDOMNode(this.input);
    setImmediate(() => {
      component.setSelectionRange(component.value.length, component.value.length);
    });
  }

  renderLabel() {
    let label = '';

    if (this.props.label) {
      label = (
        <Row className="Field__label">
          <Col id={`${this.props.id}_textFieldLabel`} xs={12}>
            <span className={this.state.isValidState ? 'Field__validField' : 'Field__invalidField'}>
              {I18n.translate(this.props.label)}
            </span>
            {this.props.required ? (
              <span id="requiredIconId" className="Field__required">
                {' '}
                •
              </span>
            ) : (
              ''
            )}
          </Col>
        </Row>
      );
    }

    return label;
  }  

  renderField() {    
    return ( 
      <Row>
        <Col xs={12}>         
          <input
            type="tel"
            id={`${this.props.id}_textFieldId`}
            onBlur={event => {this.validateField(event.target.value); this.onBlurFieldToIco(event)}}
            onChange={event => this.onChange(event.target.value)}
            placeholder={I18n.translate(this.props.placeholder)}
            maxLength={23}
            className={`data-hj-whitelist Field__input ${
              this.state.isValidState ? 'Field__validInput' : 'Field__invalidInput'
            }`}
            value={this.state.value}
            ref={ref => (this.input = ref)}
            pattern="\d*"
            style={this.props.styleEncode}
          />
        </Col>
      </Row>
    );
  }  

  onBlurFieldToIco(event){
   if(this.props.styleFieldIdentifier && this.props.callCenterMode)  
    return this.props.onBlurFieldToIco(this.props.styleFieldIdentifier,this.props.iconIdentifier,event)
  }


  renderValidationMessage() {
    let footer = <Row id={`${this.props.id}_textFieldFooter`} className="Field__message" />;

    if (!this.state.isValidState) {
      footer = (
        <Row className="Field__message error">
          <Col id={`${this.props.id}_textFieldFooter`} xs={12}>
            <span className="Field__invalidField">{I18n.translate(this.state.errorMessage)}</span>
          </Col>
        </Row>
      );
    }

    return footer;
  }

  obtainCardTypeClass(type) {
    return `CardField ${type} ${this.state.type === type ? 'selected' : ''}`;
  }

  renderCardFlags() {
    return (
      <Row>
        <Col xs={2}>
          <div className={this.obtainCardTypeClass('visa')} />
        </Col>
        <Col xs={2}>
          <div className={this.obtainCardTypeClass('mastercard')} />
        </Col>
        <Col xs={2}>
          <div className={this.obtainCardTypeClass('dinersclub')} />
        </Col>
        <Col xs={2}>
          <div className={this.obtainCardTypeClass('amex')} />
        </Col>
        <Col xs={2}>
          <div className={this.obtainCardTypeClass('elo')} />
        </Col>
        <Col xs={2}>
          <div className={this.obtainCardTypeClass('hipercard')} />
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <div id={this.props.id} className="TextField Field">
        {this.renderLabel()}
        {this.renderField()}
        {this.renderCardFlags()}
        {this.renderValidationMessage()}
      </div>
    );
  }
}

CardField.propTypes = propTypes;
CardField.defaultProps = defaultProps;

export default CardField;



// WEBPACK FOOTER //
// ./src/components/checkoutInfo/cardField/CardField.jsx